import Swiper from 'swiper';
function introSlider() {
  const sliderContainer = '.section-intro-slider';
  const $container = document.querySelector(sliderContainer);
  if (!$container) return;
  const selectors = {
    slider: '.js-intro-slider'
  };
  const swiper = new Swiper(selectors.slider, {
    speed: 800,
    effect: 'fade',
    loop: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false
    },
    fadeEffect: {
      crossFade: true
    },
    on: {
      init: function () {
        $(".swiper-progress-bar").removeClass("animate");
        $(".swiper-progress-bar").removeClass("active");
        $(".swiper-progress-bar").eq(0).addClass("animate");
        $(".swiper-progress-bar").eq(0).addClass("active");
      },
      slideChangeTransitionStart: function () {
        $(".swiper-progress-bar").removeClass("animate");
        $(".swiper-progress-bar").removeClass("active");
        $(".swiper-progress-bar").eq(0).addClass("active");
      },
      slideChangeTransitionEnd: function () {
        $(".swiper-progress-bar").eq(0).addClass("animate");
      }
    }
  });
}
function featuredSlider() {
  const sliderContainer = '.section-featured-communities';
  const $container = document.querySelector(sliderContainer);
  if (!$container) return;
  const selectors = {
    slider: '.js-featured-slider',
    pagination: '.js-featured-slider-pagination'
  };
  const swiper = new Swiper(selectors.slider, {
    speed: 400,
    spaceBetween: 100,
    autoHeight: false,
    autoplay: {
      delay: 5e3
    },
    pagination: {
      el: selectors.pagination,
      type: 'bullets',
      clickable: true
    }
  });
}
function sliderGallery() {
  const sliderContainer = '.section-gallery';
  const $container = document.querySelector(sliderContainer);
  if (!$container) return;
  const selectors = {
    slider: '.js-gallery-slider',
    btnPrev: '.js-gallery-slider-button-prev',
    btnNext: '.js-gallery-slider-button-next'
  };
  const swiper = new Swiper(selectors.slider, {
    speed: 400,
    slidesPerView: 'auto',
    spaceBetween: 80,
    navigation: {
      nextEl: selectors.btnNext,
      prevEl: selectors.btnPrev
    },
    breakpoints: {
      1024: {
        spaceBetween: 10,
        slidesPerView: 1
      }
    }
  });
}
export default function sliders() {
  introSlider();
  featuredSlider();
  sliderGallery();
}